const isLocal = window.location.hostname === 'localhost';
// const isLocal = false;

export const SALES_BASE_URL = isLocal
    ? "http://localhost:5001/api"
    : "https://api.meetelecomm.com/sales/api";

export const CRM_API_BASE_URL = isLocal
    ? "http://localhost:5000/api"
    : "https://api.meetelecomm.com/crm/api";

export const AUTH_API_BASE_URL = isLocal
    ? "http://localhost:5003/api"
    : "https://api.meetelecomm.com/auth/api";

export const ACCOUNTS_API_BASE_URL = isLocal
    ? "http://localhost:5002/api"
    : "https://api.meetelecomm.com/accounts/api";
